<div class="admin-container">
  <h2>{{pageTitle}}</h2>

  <div class="search-header">
    <!-- TABS -->
    <div class="tabs-container">
      <div class="tabs">
        <button (click)="changeAll()" class="tab" [class.active]="activeTab === 'all'">Todos
          <span class="count">({{totalTodosUsuarios}})</span>
        </button>
        <button (click)="changeNew()" class="tab" [class.active]="activeTab === 'new'">Nuevos
        </button>
      </div>
    </div>
    <!-- SEARCH BAR -->
    <div class="search-controls">
      <div class="search-container">
        <div class="search-box">
          <input type="text" [(ngModel)]="searchTerm" (input)="searchUsers()" placeholder="Buscar usuario" class="search-input">
          <button class="search-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>
      </div>
      <!-- BOTON CREAR -->
      <button (click)="newAccount()" class="btn-create">
        Crear nueva cuenta
      </button>
    </div>

  </div>


  <div class="table-container">
    <div class="loader" *ngIf="loading">Cargando...</div>

    <table *ngIf="!loading && users.length > 0">
      <thead>
        <tr>
          <th>Nombre y Apellido</th>
          <th>Correo</th>
          <th>Estado</th>
          <th>Fecha Ingreso</th>
          <th>Tipo Mentor</th>
          <th>Citas</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.status.name }}</td>
          <td>{{ user.createdAt | date : "dd/MM/yyyy" }}</td>
          <td>
            <select [(ngModel)]="user.selectedCoachTypeId" name="coachType_{{user.id}}" (change)="updateCoachType(user, $event)">
              <option value="0" disabled>Sin tipo</option>
              <option *ngFor="let item of coachTypes" [value]="item.id">
                {{ item.name }}
              </option>
            </select>
          </td>
          <td>
            <div style="display: flex; gap: 8px; align-items: center;">
              <button (click)="viewCoachAppointments(user)" class="btn-view-appointments" title="Ver citas">
                <i class="fas fa-eye"></i>
              </button>
              <button (click)="downloadCoachAppointments(user)" class="btn-download-appointments" title="Descargar reporte de citas">
                <i class="fas fa-download"></i>
              </button>
            </div>
          </td>
          <td>
            <!-- <button (click)="editUser(user)" class="btn-edit">Editar</button> -->
            <button (click)="editarUsuario(user)" class="btn-editar">Editar</button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="empty-state" *ngIf="!loading && users.length === 0">
      No hay usuarios para mostrar
    </div>
  </div>

  <!-- MODAL CREAR USUARIO -->
  <div class="modal-overlay" *ngIf="showModalForm" (click)="closeModalForm()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{editMode ? 'Editar' : 'Agregar'}} mentor</h2>
        <button class="close-button" (click)="closeModalForm()">×</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="usuarioFormGroup" (ngSubmit)="guardarUsuario()" class="example-container">
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group" style="flex: 1 1 100%;">
              <label>Nombre completo*</label>
              <input type="text" class="" placeholder="Nombre completo" formControlName="FULLNAME">
              <div *ngIf="frmUsuario['FULLNAME'].invalid && (frmUsuario['FULLNAME'].dirty || frmUsuario['FULLNAME'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FULLNAME'].hasError('required')">Nombre requerido</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Correo</label>
              <input type="email" class="" placeholder="Email" formControlName="EMAIL">
              <div *ngIf="frmUsuario['EMAIL'].invalid && (frmUsuario['EMAIL'].dirty || frmUsuario['EMAIL'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('required')">Correo requerido</span>
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('email')">Correo no válido</span>
              </div>
            </div>

            <div class="form-group">
              <label>Celular*</label>
              <input type="number" class="" style="width: 19%;margin-right: 2px;" placeholder="Code" formControlName="CODETELEFONO">
              <input type="number" class="" style="width: 80%;" placeholder="Celular" formControlName="TELEFONO">
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Fecha de Ingreso</label>
              <input type="date" class="" formControlName="FECHAINGRESO">
              <div *ngIf="frmUsuario['FECHAINGRESO'].invalid && (frmUsuario['FECHAINGRESO'].dirty || frmUsuario['FECHAINGRESO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FECHAINGRESO'].hasError('required')">Fecha requerida</span>
              </div>
            </div>

            <div class="form-group">
              <label>Tipo Mentor</label>
              <select formControlName="TIPOMENTOR">
                <option value="0" disabled>Sin tipo</option>
                <option *ngFor="let item of coachTypes" [ngValue]="item.id">
                  {{item.name}}
                </option>
              </select>
              <div *ngIf="frmUsuario['TIPOMENTOR'].invalid && (frmUsuario['TIPOMENTOR'].dirty || frmUsuario['TIPOMENTOR'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['TIPOMENTOR'].hasError('required')">Tipo requerido</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <button type="button" class="btn-cancel" (click)="closeModalForm()">Cancelar</button>
            </div>

            <div class="form-group">
              <button type="submit" class="btn-save" [disabled]="usuarioFormGroup.invalid">Guardar</button>
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <!-- <button class="cancel-button" (click)="closeModalForm()">Cerrar</button> -->
      </div>
    </div>
  </div>

  <!-- MODAL VER CITAS DEL MENTOR -->
  <div class="modal-overlay" *ngIf="showAppointmentsModal" (click)="closeAppointmentsModal()">
    <div class="modal-content appointments-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Citas de {{ selectedCoach?.name }}</h2>
        <button class="close-button" (click)="closeAppointmentsModal()">×</button>
      </div>

      <div class="modal-body">
        <div class="loading-appointments" *ngIf="loadingAppointments">
          <p>Cargando citas...</p>
        </div>

        <div class="appointments-list" *ngIf="!loadingAppointments">
          <div *ngIf="coachAppointments.length === 0" class="no-appointments">
            <p>No hay citas registradas para este mentor.</p>
          </div>

          <div *ngIf="coachAppointments.length > 0" class="appointments-container">
            <div class="appointment-item" *ngFor="let appointment of coachAppointments">
              <div class="appointment-header">
                <div class="appointment-date-time">
                  <span class="appointment-date">
                    <i class="fas fa-calendar"></i>
                    {{ appointment.date | date: 'dd/MM/yyyy' }}
                  </span>
                  <span class="appointment-time">
                    <i class="fas fa-clock"></i>
                    {{ appointment.time }}
                  </span>
                </div>
                <span class="appointment-status" [class.completed]="isAppointmentCompleted(appointment)" [class.pending]="!isAppointmentCompleted(appointment)">
                  {{ isAppointmentCompleted(appointment) ? 'Realizada' : 'Pendiente' }}
                </span>
              </div>
              
              <div class="appointment-details">
                <div class="detail-row" *ngIf="appointment.customer">
                  <strong>Cliente:</strong> {{ appointment.customer.name }}
                </div>
                <div class="detail-row" *ngIf="appointment.duration">
                  <strong>Duración:</strong> {{ appointment.duration }} minutos
                </div>
              </div>

              <div class="appointment-notes" *ngIf="appointment.notes">
                <strong>Notas:</strong>
                <div class="notes-content" [innerHTML]="appointment.notes"></div>
              </div>

              <div class="appointment-notes" *ngIf="!appointment.notes">
                <em>Sin notas registradas</em>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-close-modal" (click)="closeAppointmentsModal()">Cerrar</button>
      </div>
    </div>
  </div>

</div>